import { toggle } from 'slide-element';

export function initAlertAction(context, once) {
  once('alertAction', '.alerts', context).forEach(item => {
    item.querySelector('.alerts-toggle').addEventListener('click', e => {
      toggle(item.querySelector('.alerts-body'), {
        duration: 300,
        easing: 'ease-in-out'
      });
      if (item.classList.contains('open')) {
        item.querySelector('.alerts-toggle').ariaExpanded = 'false';
        item.classList.remove('open');
      } else {
        item.querySelector('.alerts-toggle').ariaExpanded = 'true';
        item.classList.add('open');
      }
    });
  });
}
